// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg viewBox=%270 0 100 100%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M10 50Q40 30 50 0Q60 30 90 50Q60 70 50 100Q40 70 10 50%27 fill=%27%236cb4f7%27 /></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-bg: #e6f4ff;          /* very light blue */
  --gothic-font: 'MedievalSharp', cursive;
  --accent-blue: #4a90e2;      /* 主按钮蓝调 */
  --mystic-blue: #6cb4f7;      /* 中度淡蓝，用于阴影、边框 */
  --ancient-blue: #3085b5;     /* 深蓝，替代gold */
  /* 保证整体统一在蓝色系 */
}

.app-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: var(--gothic-font);
  background: var(--main-bg);
  color: #2c3e50;
  min-height: 100vh;
  text-shadow: 0 1px 3px rgba(0,30,50,0.10);
}

.instructions-container {
  margin: 20px 0;
  background: rgba(245, 250, 255, 0.95);
  border: 1px solid var(--ancient-blue);
  border-radius: 8px;
  overflow: hidden;
}

.toggle-instructions {
  width: 100%;
  padding: 12px;
  background: rgba(230, 242, 255, 0.98);
  color: var(--ancient-blue);
  border: none;
  font-family: var(--gothic-font);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.toggle-instructions:hover {
  background: #d1eaff;
  text-shadow: 0 0 8px rgba(76,177,245, 0.15);
}

.instructions-content {
  padding: 15px;
  border-top: 1px dashed var(--accent-blue);
}

.instructions-content ul {
  padding-left: 25px;
  list-style-type: '🧊'; /* 换蓝色emoji更搭 */
}

.instructions-content li {
  margin: 8px 0;
  padding-left: 10px;
}

.instructions-container,
.instructions-content,
.question-container {
  color: #2c3e50;
}

h1,
.question-container h2 {
  color: #26425a;
}

.question-container p {
  margin-bottom: 0;
}

.question-container {
  background: linear-gradient(to bottom right, 
    rgba(230, 244, 255, 0.98), 
    rgba(200, 232, 255, 0.98)
  );
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 0px;
  position: relative;
  padding-bottom: 0;
  border: 2px solid var(--ancient-blue);
  box-shadow: 0 0 15px rgba(49, 113, 186, 0.25);
  position: relative;
  overflow: hidden;
}

.question-container::after {
  content: '';
  position: absolute;
  top: -50%;
  right: -30%;
  width: 200px;
  height: 200px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.12;
}

.button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 5px;
  margin-bottom: 10px;
}

.button-container button {
  flex: 1 1; /* 让每个按钮都可以扩展占据可用空间 */
  height: 30px; /* 减少高度 */
  margin: 0;
  padding: 0 10px; /* 调整内边距 */
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.next-question-btn {
  position: static;
  flex: 1 1;
  min-width: 80px;
  max-width: 150px;
  padding: 0.5em 1em;
  font-size: clamp(12px, 2vw, 14px);
  background: var(--accent-blue);
  color: #e6f4ff;
  border: 1px solid var(--ancient-blue);
  border-radius: 6px;
  cursor: pointer;
  text-shadow: 1px 1px 2px #174e6b;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-button {
  position: static;
  margin-right: auto;
  flex: 1 1;
  min-width: 60px;
  max-width: 250px;
  padding: 0.5em 1em;
  font-size: clamp(12px, 2vw, 14px);
  background: #d1eaff;
  color: var(--ancient-blue);
  border: 1px solid var(--accent-blue);
  border-radius: 6px;
  cursor: pointer;
  text-shadow: 1px 1px 2px #c4deef;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.previous-question-btn {
  position: static;
  margin-right: auto;
  flex: 1 1;
  min-width: 70px;
  max-width: 150px;
  padding: 0.5em 1em;
  font-size: clamp(12px, 2vw, 14px);
  background: #d1eaff;
  color: var(--ancient-blue);
  border: 1px solid var(--accent-blue);
  border-radius: 6px;
  cursor: pointer;
  text-shadow: 1px 1px 2px #c4deef;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.next-question-btn:hover {
  background: #3077b0;
  box-shadow: 0 0 10px rgba(49, 113, 186, 0.30);
  transform: scale(1.05);
}

.previous-question-btn:hover {
  background: #b6dfff;
  box-shadow: 0 0 10px rgba(49, 113, 186, 0.25);
  transform: scale(1.05);
}

.nav-container {
  display: flex;
  width: 100%;
}

@media (max-width: 768px) {
  .nav-container {
    flex-direction: row;
    justify-content: space-between;
  }
}

.chat-container {
  display: flex;
  flex-direction: column;
  min-height: 50px;
  max-height: 400px;
  margin: 20px 0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  overflow-y: auto;
}

.messages-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 15px;
}

.answer-input {
  margin-top: auto;
  padding: 15px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.input-button-group {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 0px; /* 为下方按钮留出空间 */;
}

.answer-input textarea {
  width: 100%;
  height: auto;
  min-height: 160px;
  max-height: 200px;
  padding: 12px;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 24px;
  min-width: 200px; /* 确保输入框有最小宽度 */
  max-width: 60%; /* 新增最大宽度限制 */
  resize: none;
  color: #2c3e50;
  font-family: var(--gothic-font);
  font-size: 14px;
  transition: border-color 0.3s ease, height 0.2s ease;
  flex: 1 1; /* 输入框占满剩余空间 */;
}

.answer-input textarea:focus {
  outline: none;
  border-color: var(--accent-blue);
  box-shadow: 0 0 0 2px rgba(74,144,226,0.1);
}

.nav-container {
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  background: #f5fbff;
  position: sticky;
  bottom: 0;
  z-index: 100;
  border-top: 2px solid var(--ancient-blue);
  margin-top: auto;
}

button {
  background: var(--mystic-blue);
  color: #e6f4ff;
  padding: 12px 32px;
  margin: 0 10px;
  border: 1px solid var(--ancient-blue);
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  min-width: 160px;
}

button.management-btn {
  background: #e7f2ff;
  border-color: var(--accent-blue);
}

button:hover {
  background: #4086b3;
  box-shadow: 0 0 12px rgba(49, 113, 186, 0.25);
  transform: translateY(-2px);
}

button.management-btn:hover {
  background: #d5eaff;
}

@media (max-width: 768px) {
  .nav-container {
    flex-direction: column;
    gap: 15px;
    padding: 20px;
  }
  
  button {
    width: 100%;
    margin: 5px 0;
  }
}

button:hover {
  background: #3077b0;
  box-shadow: 0 0 12px rgba(49, 113, 186, 0.35);
  transform: translateY(-2px);
}

button:disabled {
  background: #a9cbe6;
  cursor: not-allowed;
  opacity: 0.7;
}

.feedback-container {
  margin-top: 20px;
  padding: 15px;
  background: #f0f8ff;
  border-radius: 8px;
  border: 1px solid var(--accent-blue);
  position: relative;
  backdrop-filter: blur(3px);
}

.feedback-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'><text x='50%' y='50%' font-size='20' fill='rgba(76,176,245,0.10)' transform='rotate(-30 50 50)'>❄️</text></svg>");
  opacity: 0.2;
}

/* 消息气泡通用样式 */
.message {
  max-width: 70%;
  padding: 8px 0;
  transition: all 0.3s ease;
}

/* 用户消息（右对齐） */
.message.user {
  margin-left: auto;
  align-items: flex-end;
}

.message.user .bubble {
  background: #1890ff;
  color: white;
  border-radius: 18px 18px 4px 18px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 机器人消息（左对齐） */
.message.bot {
  margin-right: auto;
  align-items: flex-start;
}

.message.bot .bubble {
  background: #ffffff;
  color: #333;
  border-radius: 18px 18px 18px 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #eee;
}

/* 气泡内文字排版 */
.bubble {
  padding: 12px 16px;
  line-height: 1.5;
  font-size: 14px;
  word-break: break-word;
  white-space: pre-wrap;
}

/* 消息容器优化 */
.chat-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;
  padding: 20px;
  overflow-y: auto;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 20px 0;
  position: relative;
}

/* 首页按钮间距优化 */
.admin-panel button {
  margin: 15px;
  min-width: 180px;
}

.keywords-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* 管理页面容器样式 */
.admin-panel {
  background-color: #e6f4ff;
  padding: 2rem;
  min-height: 100vh;
}

.form-group {
  background: #f6fbff;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(68,128,188,0.06);
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.form-group label {
  margin-bottom: 4px;
}

.form-group label {
  color: #143d67;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.error-message {
  color: #226bad;
  margin-top: 0.5rem;
}

.keyword-tag {
  margin: 2px;
  padding: 4px 8px;
  background: #c8e6fa;
  border-radius: 12px;
}

/* 返回按钮样式 */
.back-button {
  position: fixed;
  top: 20px;
  left: 20px;
  padding: 10px 20px;
  background: var(--accent-blue);
  border: 1px solid var(--ancient-blue);
  color: #e6f4ff;
}

button.similarity-button:disabled {
  background: #a0bdd8;
  opacity: 0.7;
  cursor: not-allowed;
}

button.similarity-button:hover:not(:disabled) {
  background: #3077b0;
  box-shadow: 0 0 10px rgba(49, 113, 186, 0.25);
  transform: scale(1.05);
}

/* 新增弹窗样式 */
.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #fcc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  z-index: 100;
}

@keyframes slideIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.notification {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ffe9e9;
  color: #c33;
  padding: 8px 16px;
  border-radius: 4px
}

.button-group-btn {
  flex: 1 0 auto;  /* 新增flex-shrink设置 */
  min-width: 100px;  /* 设置最小宽度 */
  width: auto;  /* 替换原有的30%设置 */
  font-size: clamp(12px, 3vw, 14px);
  padding: 8px 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 2px;  /* 增加微小间距 */
}


/* 新增点赞按钮样式 */
.like-button {
  padding: 0;
  width: 64px;
  height: 32px;
  min-width: auto;
  background: none;
  border: none;
  font-size: 1.2em;
  color: var(--accent-blue);
}

.like-button:hover {
  background: none;
  transform: none;
  color: var(--accent-blue);
}

.feedback-buttons {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.feedback-buttons button {
  padding: 4px 6px;
  font-size: 12px;
  border-radius: 12px;
  background: #f0f0f0;
  border: 1px solid #666;
  color: #333;
  cursor: pointer;
  min-width: 60px;
  max-width: 100px;
}

.feedback-buttons button.active {
  background: #1890ff;
  color: white;
  border-color: #0050b3;
}

.feedback-buttons button:first-child.active {
  background: #52c41a;
  border-color: #237804;
}

.feedback-buttons button:last-child.active {
  background: #f5222d;
  border-color: #820014;
}

.attempts-counter {
  margin: 12px 0;
  padding: 8px 15px;
  background: rgba(230, 242, 255, 0.9);
  border: 1px solid #4a90e2;
  border-radius: 4px;
  color: #2c3e50;
  font-size: 14px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB,WAAW,oBAAoB;EACjD,uCAAuC;EACvC,sBAAsB,OAAO,UAAU;EACvC,sBAAsB,OAAO,iBAAiB;EAC9C,uBAAuB,MAAM,cAAc;EAC3C,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB,EAAE,eAAe;AACxC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;GAGC;EACD,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mDAAmM;EACnM,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO,EAAE,qBAAqB;EAC9B,YAAY,EAAE,SAAS;EACvB,SAAS;EACT,eAAe,EAAE,UAAU;EAC3B,mBAAmB,EAAE,WAAW;EAChC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,8BAA8B;EAC9B,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB,EAAE,cAAc;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB,EAAE,eAAe;EACjC,cAAc,EAAE,aAAa;EAC7B,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,oDAAoD;EACpD,SAAO,EAAE,cAAc;AACzB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wNAAwN;EACxN,YAAY;AACd;;AAEA,aAAa;AACb;EACE,cAAc;EACd,cAAc;EACd,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,aAAa;AACb;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB;AACF;;AAEA;EACE,cAAc,GAAG,oBAAoB;EACrC,gBAAgB,GAAG,WAAW;EAC9B,WAAW,GAAG,eAAe;EAC7B,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW,GAAG,WAAW;AAC3B;;;AAGA,aAAa;AACb;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[":root {\n  --main-bg: #e6f4ff;          /* very light blue */\n  --gothic-font: 'MedievalSharp', cursive;\n  --accent-blue: #4a90e2;      /* 主按钮蓝调 */\n  --mystic-blue: #6cb4f7;      /* 中度淡蓝，用于阴影、边框 */\n  --ancient-blue: #3085b5;     /* 深蓝，替代gold */\n  /* 保证整体统一在蓝色系 */\n}\n\n.app-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: var(--gothic-font);\n  background: var(--main-bg);\n  color: #2c3e50;\n  min-height: 100vh;\n  text-shadow: 0 1px 3px rgba(0,30,50,0.10);\n}\n\n.instructions-container {\n  margin: 20px 0;\n  background: rgba(245, 250, 255, 0.95);\n  border: 1px solid var(--ancient-blue);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.toggle-instructions {\n  width: 100%;\n  padding: 12px;\n  background: rgba(230, 242, 255, 0.98);\n  color: var(--ancient-blue);\n  border: none;\n  font-family: var(--gothic-font);\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.toggle-instructions:hover {\n  background: #d1eaff;\n  text-shadow: 0 0 8px rgba(76,177,245, 0.15);\n}\n\n.instructions-content {\n  padding: 15px;\n  border-top: 1px dashed var(--accent-blue);\n}\n\n.instructions-content ul {\n  padding-left: 25px;\n  list-style-type: '🧊'; /* 换蓝色emoji更搭 */\n}\n\n.instructions-content li {\n  margin: 8px 0;\n  padding-left: 10px;\n}\n\n.instructions-container,\n.instructions-content,\n.question-container {\n  color: #2c3e50;\n}\n\nh1,\n.question-container h2 {\n  color: #26425a;\n}\n\n.question-container p {\n  margin-bottom: 0;\n}\n\n.question-container {\n  background: linear-gradient(to bottom right, \n    rgba(230, 244, 255, 0.98), \n    rgba(200, 232, 255, 0.98)\n  );\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 0px;\n  position: relative;\n  padding-bottom: 0;\n  border: 2px solid var(--ancient-blue);\n  box-shadow: 0 0 15px rgba(49, 113, 186, 0.25);\n  position: relative;\n  overflow: hidden;\n}\n\n.question-container::after {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -30%;\n  width: 200px;\n  height: 200px;\n  background: url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'><path d='M10 50Q40 30 50 0Q60 30 90 50Q60 70 50 100Q40 70 10 50' fill='%236cb4f7' /></svg>\");\n  opacity: 0.12;\n}\n\n.button-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 5px;\n  margin-bottom: 10px;\n}\n\n.button-container button {\n  flex: 1; /* 让每个按钮都可以扩展占据可用空间 */\n  height: 30px; /* 减少高度 */\n  margin: 0;\n  padding: 0 10px; /* 调整内边距 */\n  white-space: nowrap; /* 防止文本换行 */\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.next-question-btn {\n  position: static;\n  flex: 1;\n  min-width: 80px;\n  max-width: 150px;\n  padding: 0.5em 1em;\n  font-size: clamp(12px, 2vw, 14px);\n  background: var(--accent-blue);\n  color: #e6f4ff;\n  border: 1px solid var(--ancient-blue);\n  border-radius: 6px;\n  cursor: pointer;\n  text-shadow: 1px 1px 2px #174e6b;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.home-button {\n  position: static;\n  margin-right: auto;\n  flex: 1;\n  min-width: 60px;\n  max-width: 250px;\n  padding: 0.5em 1em;\n  font-size: clamp(12px, 2vw, 14px);\n  background: #d1eaff;\n  color: var(--ancient-blue);\n  border: 1px solid var(--accent-blue);\n  border-radius: 6px;\n  cursor: pointer;\n  text-shadow: 1px 1px 2px #c4deef;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.previous-question-btn {\n  position: static;\n  margin-right: auto;\n  flex: 1;\n  min-width: 70px;\n  max-width: 150px;\n  padding: 0.5em 1em;\n  font-size: clamp(12px, 2vw, 14px);\n  background: #d1eaff;\n  color: var(--ancient-blue);\n  border: 1px solid var(--accent-blue);\n  border-radius: 6px;\n  cursor: pointer;\n  text-shadow: 1px 1px 2px #c4deef;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.next-question-btn:hover {\n  background: #3077b0;\n  box-shadow: 0 0 10px rgba(49, 113, 186, 0.30);\n  transform: scale(1.05);\n}\n\n.previous-question-btn:hover {\n  background: #b6dfff;\n  box-shadow: 0 0 10px rgba(49, 113, 186, 0.25);\n  transform: scale(1.05);\n}\n\n.nav-container {\n  display: flex;\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .nav-container {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n}\n\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 50px;\n  max-height: 400px;\n  margin: 20px 0;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  overflow-y: auto;\n}\n\n.messages-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 15px;\n}\n\n.answer-input {\n  margin-top: auto;\n  padding: 15px;\n  background: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n}\n\n.input-button-group {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 0px; /* 为下方按钮留出空间 */;\n}\n\n.answer-input textarea {\n  width: 100%;\n  height: auto;\n  min-height: 160px;\n  max-height: 200px;\n  padding: 12px;\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 24px;\n  min-width: 200px; /* 确保输入框有最小宽度 */\n  max-width: 60%; /* 新增最大宽度限制 */\n  resize: none;\n  color: #2c3e50;\n  font-family: var(--gothic-font);\n  font-size: 14px;\n  transition: border-color 0.3s ease, height 0.2s ease;\n  flex: 1; /* 输入框占满剩余空间 */;\n}\n\n.answer-input textarea:focus {\n  outline: none;\n  border-color: var(--accent-blue);\n  box-shadow: 0 0 0 2px rgba(74,144,226,0.1);\n}\n\n.nav-container {\n  display: flex;\n  justify-content: space-between;\n  padding: 15px 20px;\n  background: #f5fbff;\n  position: sticky;\n  bottom: 0;\n  z-index: 100;\n  border-top: 2px solid var(--ancient-blue);\n  margin-top: auto;\n}\n\nbutton {\n  background: var(--mystic-blue);\n  color: #e6f4ff;\n  padding: 12px 32px;\n  margin: 0 10px;\n  border: 1px solid var(--ancient-blue);\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 18px;\n  letter-spacing: 1px;\n  transition: all 0.3s ease;\n  min-width: 160px;\n}\n\nbutton.management-btn {\n  background: #e7f2ff;\n  border-color: var(--accent-blue);\n}\n\nbutton:hover {\n  background: #4086b3;\n  box-shadow: 0 0 12px rgba(49, 113, 186, 0.25);\n  transform: translateY(-2px);\n}\n\nbutton.management-btn:hover {\n  background: #d5eaff;\n}\n\n@media (max-width: 768px) {\n  .nav-container {\n    flex-direction: column;\n    gap: 15px;\n    padding: 20px;\n  }\n  \n  button {\n    width: 100%;\n    margin: 5px 0;\n  }\n}\n\nbutton:hover {\n  background: #3077b0;\n  box-shadow: 0 0 12px rgba(49, 113, 186, 0.35);\n  transform: translateY(-2px);\n}\n\nbutton:disabled {\n  background: #a9cbe6;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.feedback-container {\n  margin-top: 20px;\n  padding: 15px;\n  background: #f0f8ff;\n  border-radius: 8px;\n  border: 1px solid var(--accent-blue);\n  position: relative;\n  backdrop-filter: blur(3px);\n}\n\n.feedback-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'><text x='50%' y='50%' font-size='20' fill='rgba(76,176,245,0.10)' transform='rotate(-30 50 50)'>❄️</text></svg>\");\n  opacity: 0.2;\n}\n\n/* 消息气泡通用样式 */\n.message {\n  max-width: 70%;\n  padding: 8px 0;\n  transition: all 0.3s ease;\n}\n\n/* 用户消息（右对齐） */\n.message.user {\n  margin-left: auto;\n  align-items: flex-end;\n}\n\n.message.user .bubble {\n  background: #1890ff;\n  color: white;\n  border-radius: 18px 18px 4px 18px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* 机器人消息（左对齐） */\n.message.bot {\n  margin-right: auto;\n  align-items: flex-start;\n}\n\n.message.bot .bubble {\n  background: #ffffff;\n  color: #333;\n  border-radius: 18px 18px 18px 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  border: 1px solid #eee;\n}\n\n/* 气泡内文字排版 */\n.bubble {\n  padding: 12px 16px;\n  line-height: 1.5;\n  font-size: 14px;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n/* 消息容器优化 */\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  gap: 16px;\n  padding: 20px;\n  overflow-y: auto;\n  background: #f9f9f9;\n  border-radius: 8px;\n  margin: 20px 0;\n  position: relative;\n}\n\n/* 首页按钮间距优化 */\n.admin-panel button {\n  margin: 15px;\n  min-width: 180px;\n}\n\n.keywords-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n/* 管理页面容器样式 */\n.admin-panel {\n  background-color: #e6f4ff;\n  padding: 2rem;\n  min-height: 100vh;\n}\n\n.form-group {\n  background: #f6fbff;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(68,128,188,0.06);\n  margin-bottom: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.form-group label {\n  margin-bottom: 4px;\n}\n\n.form-group label {\n  color: #143d67;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.error-message {\n  color: #226bad;\n  margin-top: 0.5rem;\n}\n\n.keyword-tag {\n  margin: 2px;\n  padding: 4px 8px;\n  background: #c8e6fa;\n  border-radius: 12px;\n}\n\n/* 返回按钮样式 */\n.back-button {\n  position: fixed;\n  top: 20px;\n  left: 20px;\n  padding: 10px 20px;\n  background: var(--accent-blue);\n  border: 1px solid var(--ancient-blue);\n  color: #e6f4ff;\n}\n\nbutton.similarity-button:disabled {\n  background: #a0bdd8;\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\nbutton.similarity-button:hover:not(:disabled) {\n  background: #3077b0;\n  box-shadow: 0 0 10px rgba(49, 113, 186, 0.25);\n  transform: scale(1.05);\n}\n\n/* 新增弹窗样式 */\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #fcc;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  animation: slideIn 0.3s ease-out;\n  z-index: 100;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.notification {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #ffe9e9;\n  color: #c33;\n  padding: 8px 16px;\n  border-radius: 4px\n}\n\n.button-group-btn {\n  flex: 1 0 auto;  /* 新增flex-shrink设置 */\n  min-width: 100px;  /* 设置最小宽度 */\n  width: auto;  /* 替换原有的30%设置 */\n  font-size: clamp(12px, 3vw, 14px);\n  padding: 8px 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 2px;  /* 增加微小间距 */\n}\n\n\n/* 新增点赞按钮样式 */\n.like-button {\n  padding: 0;\n  width: 64px;\n  height: 32px;\n  min-width: auto;\n  background: none;\n  border: none;\n  font-size: 1.2em;\n  color: var(--accent-blue);\n}\n\n.like-button:hover {\n  background: none;\n  transform: none;\n  color: var(--accent-blue);\n}\n\n.feedback-buttons {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.feedback-buttons button {\n  padding: 4px 6px;\n  font-size: 12px;\n  border-radius: 12px;\n  background: #f0f0f0;\n  border: 1px solid #666;\n  color: #333;\n  cursor: pointer;\n  min-width: 60px;\n  max-width: 100px;\n}\n\n.feedback-buttons button.active {\n  background: #1890ff;\n  color: white;\n  border-color: #0050b3;\n}\n\n.feedback-buttons button:first-child.active {\n  background: #52c41a;\n  border-color: #237804;\n}\n\n.feedback-buttons button:last-child.active {\n  background: #f5222d;\n  border-color: #820014;\n}\n\n.attempts-counter {\n  margin: 12px 0;\n  padding: 8px 15px;\n  background: rgba(230, 242, 255, 0.9);\n  border: 1px solid #4a90e2;\n  border-radius: 4px;\n  color: #2c3e50;\n  font-size: 14px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
